import * as Common from "../../commons/common"

export class Sheet {
  id: number
  name: string = ""
  page_count: number
  width: number
  height: number
  question_image_completed: boolean
  questionImageWidth: number
  questionImageHeight: number
  test_end_datetime_at: Date
  digital_answer_type: number
  is_self_scoring_enable: boolean
  testPeriod: string = ""
  
  constructor(sheet: any){
    this.id = sheet.id;
    this.name = sheet.name;
    this.page_count = sheet.page_count;
    this.width = sheet.correct_image_size[0];
    this.height = sheet.correct_image_size[1];
    this.question_image_completed = sheet.question_image_completed;
    this.is_self_scoring_enable = sheet.is_self_scoring_enable;
    if(this.question_image_completed){
      this.questionImageWidth = sheet.question_image_size[0];
      this.questionImageHeight = sheet.question_image_size[1];
    }
    this.test_end_datetime_at = sheet.test_end_datetime_at ? new Date(sheet.test_end_datetime_at) : null;
    this.digital_answer_type = sheet.digital_answer_type;
    if(sheet.test_start_datetime_at && sheet.test_end_datetime_at){
      const format = "M月D日kk時mm分"
      this.testPeriod = `(提出期間: ${Common.formatDate(sheet.test_start_datetime_at, format)}〜${Common.formatDate(sheet.test_end_datetime_at, format)})`
    }
  }
}

export class SheetField {
  id: number
  idx: number
  page: number
  part1: string
  part2: string
  part3: string
  allot: number
  rim: number[]
  x: number
  y: number
  width: number
  height: number
  field_name: string
  base64_image: string = null
  base64_canvas: string = null
  is_canvas_drawed: boolean = false
  is_canvas_updated: boolean = false
  answer_texts: AnswerText[] = []
  answer_text_idx: number = 0
  correct_state: number = null
  sheet_field_mark: SheetFieldMark = null
  kind: number

  get isKaitouCompleted(): boolean {
    return this.is_canvas_drawed || (this.answer_texts.length > 0 && this.answer_texts.filter(x => !x.text).length == 0);
  }

  constructor(x: any, idx: number){
    this.id = x.id;
    this.idx = idx;
    this.page = x.page;
    this.part1 = x.part1;
    this.part2 = x.part2;
    this.part3 = x.part3;
    this.allot = x.allot;
    this.rim = x.rim;
    this.x = x.rim[0];
    this.y = x.rim[1];
    this.width = x.rim[2];
    this.height = x.rim[3];
    this.kind = x.kind;

    this.field_name = this.part1;
    this.field_name += this.part2 ? this.part2 : "";
    this.field_name += this.part3 ? this.part3 : "";
    this.base64_canvas = x.base64_canvas;
    this.sheet_field_mark = x.sheet_field_mark ? x.sheet_field_mark : null;
    
    for(const answer_text of x.answer_texts){

      // 未入力のテキストは削除
      if(answer_text.text == null || answer_text.text.replace(/\r?\n/g, '').trim() == "" || x.width == 0 || x.height == 0){
        continue;
      }

      const answerText = new AnswerText();
      answerText.id = answer_text.id;
      answerText.sheet_field_id = answer_text.sheet_field_id;
      answerText.text = answer_text.text;
      answerText.idx = this.answer_text_idx++;
      answerText.font_size = answer_text.font_size;
      answerText.line_height = answer_text.line_height;
      answerText.color = answer_text.color == null ? "#000000" : answer_text.color;
      answerText.x = answer_text.x;
      answerText.y = answer_text.y;
      answerText.width = answer_text.width;
      answerText.height = answer_text.height;
      this.answer_texts.push(answerText);
    }
  }
}

export interface SheetFieldMark {
  id: number
  base_sheet_field_id: number
  color: string
  x: number
  y: number
  width: number
  height: number
}

export class ParamSheetField {
  id: number
  page: number
  field_name: string
  rim: number[]
  answer_texts: AnswerText[] = []
  correct_state: number
  kind: number

  constructor(x: SheetField){
    this.id = x.id;
    this.page = x.page;
    this.field_name = x.field_name;
    this.rim = x.rim;
    this.correct_state = x.correct_state;
    this.kind = x.kind;
    this.answer_texts = x.answer_texts.map(answer_text => {
      const answerText = new AnswerText();
      answerText.sheet_field_id = answer_text.sheet_field_id;
      answerText.text = answer_text.text;
      answerText.idx = answer_text.idx;
      answerText.font_size = answer_text.font_size;
      answerText.line_height = answer_text.line_height;
      answerText.color = answer_text.color == null ? "#000000" : answer_text.color;
      answerText.x = answer_text.x;
      answerText.y = answer_text.y;
      answerText.width = answer_text.width;
      answerText.height = answer_text.height;
      return answerText;
    });
  }
}

export class PageItem {
  page_no: number
  base64_image: string
  sheet_fields: SheetField[]
  scoreing_target_sheet_fields: SheetField[]
  base_width: number
  base_height: number

  constructor(page_no: number, base64_image: string, sheet_fields: any[], base_width: number, base_height: number){
    this.page_no = page_no;
    this.base64_image = base64_image;
    this.sheet_fields = sheet_fields.filter((x: any) => x.page == this.page_no).map((x: any, idx: number) => new SheetField(x, idx));
    this.scoreing_target_sheet_fields = this.sheet_fields.filter(x => x.sheet_field_mark);
    this.base_width = base_width;
    this.base_height = base_height;
  }
}

export class AnswerText {
  id: number = null
  sheet_field_id: number = null
  idx: number = null
  text: string = null
  color: string = null
  font_size: number = null
  line_height: number = null
  x: number = null
  y: number = null
  width: number = null
  height: number = null
  base64_text: string = null
}

export class Point {
  x: number
  y: number
  
  constructor(x: number, y: number){
    this.x = x;
    this.y = y;
  }
}

export class Size {
  width: number
  height: number
  
  constructor(width: number, height: number){
    this.width = width;
    this.height = height;
  }
}

export const DirectionEnum = Object.freeze({Horizon: 1, Vertical: 2});

export const KaitouModeEnum = Object.freeze({None: 0, Text: 1, FreeLine: 2, StraightLine: 3, Eraser: 4, Delete: 5});

// 現在の工程（解答・自己採点）を表すEnum 解答・自己採点が切り替わる
export const CurrentModeEnum = Object.freeze({Answer: 1, SelfScoring: 2, Preview: 3});

// student_sheet.status 解答中・自己採点・提出済み
export const StudentSheetStatusEnum = Object.freeze({Answering: 1, SelfScoring: 2, Completed: 3});

export const CorrectStateEnum = Object.freeze({Seitou: 1, Gotou: -1, Tokuten: 0});

export const PreviewImageTypeEnum = Object.freeze({None: 0, Question: 1, Correct: 2, Answer: 3});